/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Roles, RolesInterface } from "../Roles";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "_avatar",
        type: "address",
      },
      {
        internalType: "address",
        name: "_target",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ArraysDifferentLength",
    type: "error",
  },
  {
    inputs: [],
    name: "ModuleTransactionFailed",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "module",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint16[]",
        name: "roles",
        type: "uint16[]",
      },
      {
        indexed: false,
        internalType: "bool[]",
        name: "memberOf",
        type: "bool[]",
      },
    ],
    name: "AssignRoles",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousAvatar",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newAvatar",
        type: "address",
      },
    ],
    name: "AvatarSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "guard",
        type: "address",
      },
    ],
    name: "ChangedGuard",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "DisabledModule",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "EnabledModule",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "initiator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "avatar",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "RolesModSetup",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "module",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "defaultRole",
        type: "uint16",
      },
    ],
    name: "SetDefaultRole",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "multisendAddress",
        type: "address",
      },
    ],
    name: "SetMultisendAddress",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousTarget",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newTarget",
        type: "address",
      },
    ],
    name: "TargetSet",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "allowTarget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
      {
        internalType: "uint16[]",
        name: "_roles",
        type: "uint16[]",
      },
      {
        internalType: "bool[]",
        name: "memberOf",
        type: "bool[]",
      },
    ],
    name: "assignRoles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "avatar",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "defaultRoles",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "prevModule",
        type: "address",
      },
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "disableModule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "enableModule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Enum.Operation",
        name: "operation",
        type: "uint8",
      },
    ],
    name: "execTransactionFromModule",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Enum.Operation",
        name: "operation",
        type: "uint8",
      },
    ],
    name: "execTransactionFromModuleReturnData",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Enum.Operation",
        name: "operation",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "bool",
        name: "shouldRevert",
        type: "bool",
      },
    ],
    name: "execTransactionWithRole",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Enum.Operation",
        name: "operation",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "bool",
        name: "shouldRevert",
        type: "bool",
      },
    ],
    name: "execTransactionWithRoleReturnData",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
      {
        internalType: "bytes",
        name: "returnData",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getGuard",
    outputs: [
      {
        internalType: "address",
        name: "_guard",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "start",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "pageSize",
        type: "uint256",
      },
    ],
    name: "getModulesPaginated",
    outputs: [
      {
        internalType: "address[]",
        name: "array",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "next",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "guard",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_module",
        type: "address",
      },
    ],
    name: "isModuleEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "multisend",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
    ],
    name: "revokeTarget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "scopeAllowFunction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "bool[]",
        name: "isParamScoped",
        type: "bool[]",
      },
      {
        internalType: "enum ParameterType[]",
        name: "paramType",
        type: "uint8[]",
      },
      {
        internalType: "enum Comparison[]",
        name: "paramComp",
        type: "uint8[]",
      },
      {
        internalType: "bytes[]",
        name: "compValue",
        type: "bytes[]",
      },
      {
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "scopeFunction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "scopeFunctionExecutionOptions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "uint256",
        name: "paramIndex",
        type: "uint256",
      },
      {
        internalType: "enum ParameterType",
        name: "paramType",
        type: "uint8",
      },
      {
        internalType: "enum Comparison",
        name: "paramComp",
        type: "uint8",
      },
      {
        internalType: "bytes",
        name: "compValue",
        type: "bytes",
      },
    ],
    name: "scopeParameter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "uint256",
        name: "paramIndex",
        type: "uint256",
      },
      {
        internalType: "enum ParameterType",
        name: "paramType",
        type: "uint8",
      },
      {
        internalType: "bytes[]",
        name: "compValues",
        type: "bytes[]",
      },
    ],
    name: "scopeParameterAsOneOf",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
    ],
    name: "scopeRevokeFunction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
    ],
    name: "scopeTarget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_avatar",
        type: "address",
      },
    ],
    name: "setAvatar",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
    ],
    name: "setDefaultRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_guard",
        type: "address",
      },
    ],
    name: "setGuard",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_multisend",
        type: "address",
      },
    ],
    name: "setMultisend",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_target",
        type: "address",
      },
    ],
    name: "setTarget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "initParams",
        type: "bytes",
      },
    ],
    name: "setUp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "target",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "uint8",
        name: "paramIndex",
        type: "uint8",
      },
    ],
    name: "unscopeParameter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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__$26c8ee7675adcd4387514ebc7646e15ffa$__9163a2f6f6d09161057a9190879087908790600401612fc5565b60006040518083038186803b15801561059257600080fd5b505af41580156105a6573d6000803e3d6000fd5b50505050505050565b336105b86111db565b6001600160a01b0316146105de5760405162461bcd60e51b81526004016104a090612c4e565b6001600160a01b0382166000818152606a6020908152604091829020805461ffff191661ffff86169081179091558251938452908301527f197e61bb67ba4b0f657afcb5d2dbed385d50b697c51090f466cdbcc4c30a21ce91015b60405180910390a15050565b3361064e6111db565b6001600160a01b0316146106745760405162461bcd60e51b81526004016104a090612c4e565b61ffff84166000908152606b602052604090819020905163163592dd60e01b815273__$26c8ee7675adcd4387514ebc7646e15ffa$__9163163592dd916106c691908890889088908890600401612e21565b60006040518083038186803b1580156106de57600080fd5b505af41580156106f2573d6000803e3d6000fd5b5050505050505050565b336107056111db565b6001600160a01b03161461072b5760405162461bcd60e51b81526004016104a090612c4e565b61ffff83166000818152606b6020526040908190209051631df3fe0160e21b8152600481019190915260248101919091526001600160a01b03831660448201526001600160e01b03198216606482015273__$26c8ee7675adcd4387514ebc7646e15ffa$__906377cff8049060840161057a565b600060016001600160a01b038316148015906107d457506001600160a01b038281166000908152606860205260409020541615155b92915050565b336107e36111db565b6001600160a01b0316146108095760405162461bcd60e51b81526004016104a090612c4e565b61ffff84166000818152606b6020526040908190209051631e2d127160e11b8152600481019190915260248101919091526001600160a01b03841660448201526001600160e01b03198316606482015260ff8216608482015273__$26c8ee7675adcd4387514ebc7646e15ffa$__90633c5a24e29060a4016106c6565b3361088f6111db565b6001600160a01b0316146108b55760405162461bcd60e51b81526004016104a090612c4e565b61ffff84166000908152606b6020526040908190209051630bd7754d60e31b815273__$26c8ee7675adcd4387514ebc7646e15ffa$__91635ebbaa68916106c691908890889088908890600401612e21565b336109106111db565b6001600160a01b0316146109365760405162461bcd60e51b81526004016104a090612c4e565b61ffff8b166000908152606b6020526040908190209051632af6aecb60e01b815273__$26c8ee7675adcd4387514ebc7646e15ffa$__91632af6aecb9161099691908f908f908f908f908f908f908f908f908f908f908f90600401612d52565b60006040518083038186803b1580156109ae57600080fd5b505af41580156109c2573d6000803e3d6000fd5b505050505050505050505050505050565b336109dc6111db565b6001600160a01b031614610a025760405162461bcd60e51b81526004016104a090612c4e565b61ffff88166000908152606b602052604090819020905163edf909e360e01b815273__$26c8ee7675adcd4387514ebc7646e15ffa$__9163edf909e391610a5c91908c908c908c908c908c908c908c908c90600401612f4e565b60006040518083038186803b158015610a7457600080fd5b505af4158015610a88573d6000803e3d6000fd5b505050505050505050505050565b336000908152606860205260408120546001600160a01b0316610acb5760405162461bcd60e51b81526004016104a090612c83565b336000908152606a602090815260408083205461ffff168352606b90915290819020606954915163db50e57560e01b815273__$26c8ee7675adcd4387514ebc7646e15ffa$__9263db50e57592610b3a9290916001600160a01b0316908b908b908b908b908b90600401612cda565b60006040518083038186803b158015610b5257600080fd5b505af4158015610b66573d6000803e3d6000fd5b50505050610bad868686868080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250889250611a47915050565b90505b95945050505050565b33610bc26111db565b6001600160a01b031614610be85760405162461bcd60e51b81526004016104a090612c4e565b61ffff82166000908152606b60205260409081902090516367f218bd60e11b815273__$26c8ee7675adcd4387514ebc7646e15ffa$__9163cfe4317a91610c36919086908690600401612d2f565b60006040518083038186803b158015610c4e57600080fd5b505af4158015610c62573d6000803e3d6000fd5b505050505050565b336000908152606860205260408120546060906001600160a01b0316610ca25760405162461bcd60e51b81526004016104a090612c83565b336000908152606a602090815260408083205461ffff168352606b90915290819020606954915163db50e57560e01b815273__$26c8ee7675adcd4387514ebc7646e15ffa$__9263db50e57592610d119290916001600160a01b0316908c908c908c908c908c90600401612cda565b60006040518083038186803b158015610d2957600080fd5b505af4158015610d3d573d6000803e3d6000fd5b50505050610d84878787878080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250899250611bf8915050565b915091509550959350505050565b33610d9b6111db565b6001600160a01b031614610dc15760405162461bcd60e51b81526004016104a090612c4e565b61ffff82166000908152606b602052604090819020905163ee54ca5360e01b815273__$26c8ee7675adcd4387514ebc7646e15ffa$__9163ee54ca5391610c36919086908690600401612d2f565b33610e186111db565b6001600160a01b031614610e3e5760405162461bcd60e51b81526004016104a090612c4e565b6001600160a01b03811615801590610e6057506001600160a01b038116600114155b610e7c5760405162461bcd60e51b81526004016104a090612cb2565b6001600160a01b038181166000908152606860205260409020541615610edd5760405162461bcd60e51b8152602060048201526016602482015275135bd91d5b1948185b1c9958591e48195b98589b195960521b60448201526064016104a0565b606860205260008051602061317083398151915280546001600160a01b03838116600081815260408082208054949095166001600160a01b03199485161790945560019052835490911617909155517fecdf3a3effea5783a3c4c2140e677577666428d44ed9d474a0b3a4c9943f844090610f59908390612a17565b60405180910390a150565b336000908152606860205260408120546001600160a01b0316610f995760405162461bcd60e51b81526004016104a090612c83565b61ffff83166000908152606b602052604090819020606954915163db50e57560e01b815273__$26c8ee7675adcd4387514ebc7646e15ffa$__9263db50e57592610ffb9290916001600160a01b0316908d908d908d908d908d90600401612cda565b60006040518083038186803b15801561101357600080fd5b505af4158015611027573d6000803e3d6000fd5b5050505061106e888888888080601f0160208091040260200160405190810160405280939291908181526020018383808284376000920191909152508a9250611a47915050565b905081801561107b575080155b156110995760405163d27b44a960e01b815260040160405180910390fd5b979650505050505050565b336110ad6111db565b6001600160a01b0316146110d35760405162461bcd60e51b81526004016104a090612c4e565b6110dd6000611db3565b565b336110e86111db565b6001600160a01b03161461110e5760405162461bcd60e51b81526004016104a090612c4e565b606780546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f90cc2f570a6eb594b1580ea3e41247d2d73a55281889e86bd4ec2fc29c7e62d690600090a35050565b336111696111db565b6001600160a01b03161461118f5760405162461bcd60e51b81526004016104a090612c4e565b606980546001600160a01b0319166001600160a01b0383169081179091556040517f5fe6aabf4e790843df43ae0e22b58620066fb389295bedc06a92df6c3b28777d91610f5991612a17565b6033546001600160a01b031690565b336111f36111db565b6001600160a01b0316146112195760405162461bcd60e51b81526004016104a090612c4e565b61ffff87166000908152606b6020526040908190209051632896707960e11b815273__$26c8ee7675adcd4387514ebc7646e15ffa$__9163512ce0f29161127191908b908b908b908b908b908b908b90600401612e6a565b60006040518083038186803b15801561128957600080fd5b505af415801561129d573d6000803e3d6000fd5b5050505050505050505050565b6000806000838060200190518101906112c391906121b4565b9250925092506112d1611e05565b606680546001600160a01b038085166001600160a01b031992831617909255606780549284169290911691909117905561130a836119a7565b611312611e80565b816001600160a01b0316836001600160a01b0316336001600160a01b03167f34d3b96a088381c6843a1f9d94d251afa88f83cc7a0d17fc23a7057506a3fc6d8460405161135f9190612a17565b60405180910390a450505050565b336113766111db565b6001600160a01b03161461139c5760405162461bcd60e51b81526004016104a090612c4e565b8281146113bc576040516374f4d53760e01b815260040160405180910390fd5b60005b61ffff81168411156114705782828261ffff168181106113e1576113e1613103565b90506020020160208101906113f69190612422565b606b600087878561ffff1681811061141057611410613103565b9050602002016020810190611425919061251c565b61ffff168152602080820192909252604090810160009081206001600160a01b038b1682529092529020805460ff19169115159190911790558061146881613084565b9150506113bf565b5061147a8561079f565b6114875761148785610e0f565b7f4dcd99505817a4d3e4d3f751a4a49739ec38cb0f83319ff1224a3b289597e86c85858585856040516114be959493929190612a2b565b60405180910390a15050505050565b336000908152606860205260408120546060906001600160a01b03166115055760405162461bcd60e51b81526004016104a090612c83565b61ffff84166000908152606b602052604090819020606954915163db50e57560e01b815273__$26c8ee7675adcd4387514ebc7646e15ffa$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";

type RolesConstructorParams =
  | [linkLibraryAddresses: RolesLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RolesConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class Roles__factory extends ContractFactory {
  constructor(...args: RolesConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(_abi, Roles__factory.linkBytecode(linkLibraryAddresses), signer);
    }
    this.contractName = "Roles";
  }

  static linkBytecode(linkLibraryAddresses: RolesLibraryAddresses): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$26c8ee7675adcd4387514ebc7646e15ffa\\$__", "g"),
      linkLibraryAddresses["contracts/Permissions.sol:Permissions"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  deploy(
    _owner: string,
    _avatar: string,
    _target: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Roles> {
    return super.deploy(
      _owner,
      _avatar,
      _target,
      overrides || {}
    ) as Promise<Roles>;
  }
  getDeployTransaction(
    _owner: string,
    _avatar: string,
    _target: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _owner,
      _avatar,
      _target,
      overrides || {}
    );
  }
  attach(address: string): Roles {
    return super.attach(address) as Roles;
  }
  connect(signer: Signer): Roles__factory {
    return super.connect(signer) as Roles__factory;
  }
  static readonly contractName: "Roles";
  public readonly contractName: "Roles";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RolesInterface {
    return new utils.Interface(_abi) as RolesInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Roles {
    return new Contract(address, _abi, signerOrProvider) as Roles;
  }
}

export interface RolesLibraryAddresses {
  ["contracts/Permissions.sol:Permissions"]: string;
}
